/* eslint no-param-reassign: "warn" */

import { LAYOUT } from '../../../reactor/common';

export default ({ logScroll, pages = [], scroll = 0 } = {}) => {
  const offset = scroll + LAYOUT.VIEWPORT.H;

  pages.forEach((page) => {
    const { height, y } = page;
    let visibility = 0;

    if (y <= offset && (y + height) >= scroll) {
      const viewHeight = scroll >= y ? height - (scroll - y) : offset - y;
      visibility = viewHeight / height;
      visibility = visibility >= 1 ? 1 : visibility % 1;
    }

    if (visibility > 0.8 && !page.viewed) page.viewed = true;

    page.visibility = visibility;
  });

  if (logScroll) logScroll(pages.map(({ visibility }) => visibility));

  return pages;
};
